// =====================================
// NO EDITAR ESTE ARCHIVO DIRECTO
// COMPILADO 2025-10-02 13:47:24
// =====================================

enum PAYMENTS{
	_ID = 1,		// Pagos
	VIEW_PAYMENTS = 1000,		// Ver pagos
	REFUND_PAYMENTS = 1001,		// Reembolsar pago
}
enum USERS{
	_ID = 2,		// Usuarios
	VIEW_USERS = 2000,		// Ver usuarios
	EDIT_USER_ACCESS = 2001,		// Editar permisos usuarios
}
enum PAYOUTS{
	_ID = 3,		// Liquidaciones
	VIEW_PAYOUTS = 3000,		// Ver liquidaciones
}
enum DEVELOPER{
	_ID = 20,		// Desarrollador
	SANDBOX = 20000,		// Modo sandbox
	VIEW_WEBHOOKS = 20001,		// Ver webhooks
	EDIT_WEBHOOKS = 20002,		// Editar webhooks
	RESEND_WEBHOOKS = 20003,		// Reenviar webhooks
}
const ACCESS_ARRAY = [
	{
		id: 1,
		varname: 'PAYMENTS',
		name: 'Pagos',
		access: [
			{ id: 1000, name: 'Ver pagos' },
			{ id: 1001, name: 'Reembolsar pago' },
		],
	},
	{
		id: 2,
		varname: 'USERS',
		name: 'Usuarios',
		access: [
			{ id: 2000, name: 'Ver usuarios' },
			{ id: 2001, name: 'Editar permisos usuarios' },
		],
	},
	{
		id: 3,
		varname: 'PAYOUTS',
		name: 'Liquidaciones',
		access: [
			{ id: 3000, name: 'Ver liquidaciones' },
		],
	},
	{
		id: 20,
		varname: 'DEVELOPER',
		name: 'Desarrollador',
		access: [
			{ id: 20000, name: 'Modo sandbox' },
			{ id: 20001, name: 'Ver webhooks' },
			{ id: 20002, name: 'Editar webhooks' },
			{ id: 20003, name: 'Reenviar webhooks' },
		],
	},
]

export default {
	ACCESS_ARRAY,
	PAYMENTS,
	USERS,
	PAYOUTS,
	DEVELOPER,
}